import * as React from 'react';
import { Link } from 'react-router-dom';
import EditToListingAction, { RenderEditToListingActionProps } from './EditToListingAction';

interface EditCancelButtonProps {
	label?: string;
}

/**
 * UI for the "Cancel" button.
 */
function EditCancelButton(props: EditCancelButtonProps) {
	const { label = 'Cancel' } = props;

	return (
		<EditToListingAction>
			{({ lastLocationPathAndQuery }: RenderEditToListingActionProps) => (
				<Link
					to={lastLocationPathAndQuery}
					data-testid="edit-cancel-button"
					className="btn btn-outline-primary-alt btn-width-normal btn-medium"
				>
					{label}
				</Link>
			)}
		</EditToListingAction>
	);
}

export default EditCancelButton;
